import { useParams, Navigate } from 'react-router-dom';
import EditApplication from 'src/pages/Permits/RoadPermit/EditApplication';
import EditApplicationTreePermit from 'src/pages/Permits/TreePermit/EditApplication/EditApplicationTreePermit';
import EditApplicationPlanningPermit from 'src/pages/Permits/PlanningAndZoningPermit/EditApplication';
import EditApplicationSolicitor from 'src/pages/Permits/Solicitor/EditApplication';
import EditApplicationCharitableSolicitations from 'src/pages/Permits/CharitableSolicitationsPermit/EditApplication';
import EditApplicationUsedCarDealer from 'src/pages/Permits/UsedCarDealer/EditApplication';
import VendingEditApplication from 'src/pages/Permits/ClerkVending/VendingEditApplication'
import EditApplicationConstruction from 'src/pages/Permits/Construction/EditApplication';
import EditApplicationPet from 'src/pages/Permits/PetPermit/EditApplication';
import FoodEditApplication from 'src/pages/Permits/Food&BeverageLicenseManagment/EditApplication';

const EditApplicationsRedirectHandler = () => {
  const { department, permit } = useParams();

  if (department === 'Engineering Department' && permit === '2') {
    return <EditApplication />;
  } else if (department === 'Engineering Department' && permit === '4') {
    return <EditApplicationTreePermit />;
  } else if (department === 'Planning Department' && permit === '1') {
    return <EditApplicationPlanningPermit />;
  } else if (department === 'Clerk Department' && permit === '6') {
    return <EditApplicationSolicitor />;
  } else if (department === 'Clerk Department' && permit === '5') {
    return <EditApplicationCharitableSolicitations />;
  } else if (department === 'Clerk Department' && permit === '7') {
    return <EditApplicationUsedCarDealer />;
  } else if (department === 'Clerk Department' && permit === '8') {
    return <VendingEditApplication />;
  } else if (department === 'Building or Construction Department' && permit === '9') {
    return <EditApplicationConstruction />;
  } else if (department === 'Department of Health or Animal Control' && permit === '10') {
    return <EditApplicationPet />;
  } else if (department === 'Department of Health and Mental Hygiene' && permit === '12') {
    return <FoodEditApplication />;
  }

  return <Navigate to="/unauthorized" />;
};

export default EditApplicationsRedirectHandler;
